/* eslint-disable unused-imports/no-unused-vars */
import { useCallback, useEffect, useMemo, useRef, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { courtWeekday, formatCourtDate } from "@/Utils/litigationDates.mjs";
import VerifiedIcon from "@/assets/verfication_svgs/verified_yes.svg";
import verifiedNoIcon from "@/assets/verfication_svgs/verified_no.svg";
import verifiedReadyIcon from "@/assets/verfication_svgs/verified_ready.svg";
import ClientDocumentRow from "@/Components/DocumentRow/ClientDocumentRow";

import { useAccessValidation } from "../Providers/ProtectedRoute";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import Footer from "../Components/common/footer";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import {
  addClickRecord,
  fetchPageObject,
  fetchShakespeareStatus,
  formatCalendarDate,
  getCaseId,
  getClientId,
  setCaseId,
  setClientId,
} from "../Utils/helper";
import {
  fetchAllPages,
  fetchCurrentCase,
  setCaseSummary,
  setCurrentCase,
} from "../Redux/caseData/caseDataSlice";
import { setClientProviders, setLoading } from "../Redux/client-providers/clientProviderSlice";
import { api_without_cancellation } from "../api/api";
import { fetchCaseSummary, fetchHeaderSummary } from "../api/case";
import useCoCounsel from "../Components/CaseDashboard/CoCounsel/useCoCounsel";
import CoCounselFirmRow from "../Components/CaseDashboard/CoCounsel/CoCounselFirmRow";
import incidentIcon from "../assets/images/incident.svg";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import { WorkersOnCase } from "../Components/CaseDashboard/CaseWorkes";
import "./newCasePage.css";
import NewCasePanels from "../Components/CaseDashboard/newCasePage/new-case-page-panel";
import ClientsOnCasePanel from "../Components/CaseDashboard/newCasePage/ClientsOnCasePanel";
import useCaseHomePanelsLayout from "../Components/CaseDashboard/newCasePage/useCaseHomePanelsLayout";
import { buildCaseTimelineSections } from "../Components/CaseDashboard/newCasePage/caseTimeline.mjs";
import AddNewClientModal from "../Components/Modals/addNewClientModal";
// import ContactPanelForTreatment from "../Components/TreatmentPage/components/ContactPanelForTreatment";
import ChangeOfficeFirmLocationModal from "../Components/Modals/ChangeFirmOfficeModal2";
import CounsellingModal from "../Components/Modals/counsellingModal";
import DefaultThumbnail from "../Components/common/defaultPhotoSlot";
import MedicalProviders from "../Components/CaseDashboard/MedicalProvidersTable/MedicalProviders";
import MedicalProvidersTable from "../Components/CaseDashboard/MedicalProvidersTable/MedicalProviderTable";
import ClientProvidersStyles from "../Components/CaseDashboard/ClientProvidersStyles";
import EditCaseTypeDateModal from "../Components/EditCaseTypeDateModal";
// import ResponsiveTabThreeItems from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabThreeItems";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import PageDocsTab from "../Components/DocPage/new-tab/page-docs-tab";
import CasePageContactPanel from "../Components/common/CasePageContactPanel";
import {
  useGetCaseProviders,
  useGetCaseSpecialities,
} from "../Components/TreatmentPage/hooks/useApiResource";
import CasePageFilters from "../Components/CaseDashboard/CasePageFilters";
import { useDocumentModal } from "../Components/common/CustomModal/CustomModalContext";
import AddNewProvider from "../Components/TreatmentPage/modals/AddNewProvider";
import { setComponentLoadingEffect } from "../Redux/common/Loader/action";
import { setBlurEffect } from "../Redux/header_blur/action";
import { setHeaderName } from "../Redux/header_name/action";
import { setHeaderSummary } from "../Redux/header/headerDataSlice";
import { fetchCasePageClientProviders } from "../api/clientProviders";
import EditSOLPopup from "../Components/LitigationDashboard/Modals/EditSOLPopup";
import SOLActPopupCasePage from "../Components/CaseDashboard/modals/SOLActPopupCasePage";
import { ClientDataContext } from "../Components/ClientDashboard/shared/DataContext";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import VerifyCompletionModal from "../Components/common/VerifyCompletionModal";
import VerifyBlockedModal from "../Components/common/VerifyBlockedModal";
import VerifyCompleteUndoModal from "../Components/common/VerifyUndoModal";
import { useTelephonySettings } from "../Hooks/useGetTelephonySettings";
import usePageAttachmentCounts from "../Hooks/usePageAttachmentCounts";
import SOLicon from "../assets/litigation/sol.svg";
import ExpertDiscovery from "../assets/litigation/expert_discovery.svg";
import avatarImage from "../assets/images/avatar.svg";

const EVENT_TYPE_ICONS = {
  Filing: "ic-Filing",
  Hearing: "ic-Hearing",
  Motion: "ic-Motion",
  Discovery: "ic-discovery",
  Deposition: "ic-Deposition",
  Exam: "ic-Exam",
  Trial: "ic-Trial",
  Deadline: "ic-Deadline",
  Event: "ic-Event",
  Subpoenas: "ic-Event",
  "Expert Discovery": "ic-discovery",
  "Case Initiation": "ic-Case-Initiation",
  "Mediation / Arbitration": "ic-Mediation-Arbitration",
  "Settlement Conference": "ic-Settlement-Conference",
  Answer: "ic-Answer",
};

const DATE_FORMAT_OPTIONS = {
  month: "short",
  day: "2-digit",
  year: "numeric",
  timeZone: "UTC",
};
const PHOTO_ICON_URL =
  "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg";

const STYLES = {
  incidentIcon: { width: "15px", height: "15px" },
  labelText: { fontSize: "14px", color: "var(--primary-25)" },
};

const formatDateWithAbbreviation = (dateString) => {
  if (!dateString) return null;

  return new Date(dateString)
    .toLocaleDateString("en-US", DATE_FORMAT_OPTIONS)
    .replace(/(\w+)\s(\d+),/, "$1. $2,");
};

const renderStatusLabel = (status = "OPEN", secondaryText = "Intake", dateClosed = null) => (
  <>
    <span className={`${dateClosed ? "color-grey-2" : "color-green"}`}>{status}</span> /{" "}
    {secondaryText}
  </>
);

const imageStyles = {
  maxHeight: "155px",
  maxWidth: "255px",
  width: "auto",
  height: "auto",
  objectFit: "contain",
};

const defaultThumbnailProps = {
  height: "155px",
  width: "255px",
  borderColor: "var(--primary-15)",
};

// why here brother?
export const PhotoSlot = ({
  photoSlot,
  photoSlots,
  pageName = "",
  isPanel = false,
  panelId,
  slotNumber,
  height = "155",
  width = "255",
  refetch = () => {},
}) => {
  const [hasMismatch, setHasMismatch] = useState(false);
  const { showDocumentModal } = useDocumentModal();

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    const imgRatio = naturalWidth / naturalHeight;
    const containerRatio = 255 / 155;
    setHasMismatch(Math.abs(imgRatio - containerRatio) > 0.01);
  };
  const results = { results: [photoSlot] };
  const renderImage = () => {
    if (photoSlot?.image) {
      return (
        <div
          style={{
            height: `${height}px`,
            width: `${width}px`,
            position: "relative",
            overflow: "hidden",
            backgroundColor: "var(--primary-25)",
          }}
        >
          <img
            onClick={() => {
              showDocumentModal(
                "photo",
                photoSlot?.image,
                photoSlot,
                results,
                refetch,
                photoSlot?.case_thumbnail
              );
            }}
            src={photoSlot.image}
            alt={`Case photo ${slotNumber}`}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "contain",
              objectPosition: "center",
              display: "block",
            }}
          />
        </div>
      );
    }

    return (
      <DefaultThumbnail
        {...defaultThumbnailProps}
        height={`${height}px`}
        width={`${width}px`}
        photoData={photoSlot}
        photoSlots={photoSlots}
        pageName={pageName}
        isPanel={isPanel}
        panelId={panelId}
        refetch={refetch}
      />
    );
  };

  return (
    <div
      className={`image-${slotNumber}`}
      style={{
        width: "155px",
        minWidth: "min-content",
        maxWidth: "255px",
        height: `${height}px`,
      }}
    >
      <div
        style={{
          height: `${height}px`,
        }}
        className="img-cover-block img-box d-flex align-items-center"
      >
        {renderImage()}
      </div>
    </div>
  );
};

const createCounselingFirmsData = (data, onInviteSent) => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.map((firm, index) => ({
    id: `firm-${firm.id || index}`,
    label: <CoCounselFirmRow firm={firm} index={index} onInviteSent={onInviteSent} />,
    value: firm.id,
    type: "counseling_firm",
    firmData: firm,
  }));
};

const createClientsData = (caseSummaryState) => {
  if (!caseSummaryState) return [];

  const processedClients = [];

  if (caseSummaryState.for_client) {
    const singleClient = {
      ...caseSummaryState.for_client,
      id: caseSummaryState.for_client.id,
      profilePic: caseSummaryState.for_client.profile_pic_19p,
      firstName: caseSummaryState.for_client.first_name,
      lastName: caseSummaryState.for_client.last_name,
      birthday: caseSummaryState.for_client.birthday,
      isEmpty: false,
    };

    if (singleClient.firstName || singleClient.lastName) {
      processedClients.push(singleClient);
    }
  }

  if (caseSummaryState.multipleClient_for_case?.length > 0) {
    const multipleClients = caseSummaryState.multipleClient_for_case
      .map((clientWrapper) => ({
        ...clientWrapper.new_client,
        id: clientWrapper.new_client.id,
        profilePic: clientWrapper.new_client.profile_pic_19p,
        firstName: clientWrapper.new_client.first_name,
        lastName: clientWrapper.new_client.last_name,
        birthday: clientWrapper.new_client.birthday,
        isEmpty: false,
      }))
      .filter((client) => client.firstName || client.lastName); // Only include clients with names

    processedClients.push(...multipleClients);
  }

  return processedClients.map((client, index) => ({
    id: `client-${client.id || index}`,
    clientData: client,
  }));
};

const createStatuteLimitationsData = (caseSummaryState) => {
  const limitations = caseSummaryState || [];
  if (!Array.isArray(limitations) || limitations.length === 0) {
    return [];
  }
  return limitations
    .filter((item) => item?.start_date && item?.date_name)
    .map((caseItem, index) => ({
      id: `statute-${index}`,
      baseObj: caseItem,
      label: caseItem.date_name,
      value: formatDateWithAbbreviation(caseItem.start_date),
      rawDate: caseItem.start_date,
      type: "statute-limitation",
      eventTypeId: caseItem?.event_type_id,
      eventName: caseItem?.name,
    }))
    .sort((a, b) => new Date(a.rawDate) - new Date(b.rawDate));
};
const getLatestDisposition = (caseSummaryState) => {
  const dispositions = [
    { label: "Accepted:", value: formatCalendarDate(caseSummaryState.accepted_date) },
    { label: "Rejected:", value: formatCalendarDate(caseSummaryState.case_rejected) },
    { label: "Referred:", value: formatCalendarDate(caseSummaryState.case_referred) },
    { label: "Dropped:", value: formatCalendarDate(caseSummaryState.case_dropped) },
  ].filter((d) => d.value); // exclude nulls/undefined

  if (!dispositions.length) {
    return { label: "Accepted:", value: null };
  }

  return dispositions.reduce((latest, current) => {
    return new Date(current.value) > new Date(latest.value) ? current : latest;
  });
};

const createCaseSummaryData = (caseSummaryState) => {
  if (!caseSummaryState) return [];
  const disposition = getLatestDisposition(caseSummaryState); // 👈
  return [
    {
      id: "incident-date",
      label: (
        <span
          className="text-label font-weight-semibold d-flex align-items-center"
          style={STYLES.labelText}
        >
          <img
            src={incidentIcon}
            className="m-r-5"
            style={STYLES.incidentIcon}
            alt="Incident icon"
          />
          Incident Date
        </span>
      ),
      value: formatCalendarDate(caseSummaryState.incident_date),
      type: "date",
    },
    {
      id: "status-intake",
      label: renderStatusLabel(caseSummaryState.status, "Intake", caseSummaryState.date_closed),
      value: formatCalendarDate(caseSummaryState.intake_date),
      type: "status-date",
    },
    {
      id: "retained",
      label: "Retained:",
      value: formatCalendarDate(caseSummaryState.retained),
      type: "date",
    },
    {
      id: "disposition", // 👈 was "accepted"
      label: disposition.label, // 👈 dynamic
      value: disposition.value, // 👈 dynamic
      type: "date",
    },
    {
      id: "closed",
      label: "Closed:",
      value: formatCalendarDate(caseSummaryState.date_closed),
      type: "date",
    },
  ];
};

const NewCasePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isValid } = useAccessValidation();
  const currentCaseId = getCaseId();
  const clientId = getClientId();
  const { hasDocs, hasPhotos, refreshDocs, refreshPhotos } = usePageAttachmentCounts(
    currentCaseId,
    1
  );

  const [editDetail, setEditDetail] = useState(null);
  const [litigationData, setLitigationData] = useState({});
  const [showActPopup, setShowActPopup] = useState(false);
  // const [eventTypesData, setEventTypesData] = useState([]);
  const [isBlocked, setIsBlocked] = useState(false);
  const { isLitigationActDataUpdated, setLitigationActDataUpdated } = useContext(ClientDataContext);

  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (currentCaseId && !pageObject) {
      fetchPageObject(currentCaseId, 1).then((data) => {
        setPageObject(data);
      });
    }
  }, [currentCaseId, pageObject]);

  useEffect(() => {
    const newClientID = location.pathname.split("/")[2];
    const newCaseID = location.pathname.split("/")[3];
    const clientID = getClientId();
    const caseID = getCaseId();

    if (newClientID !== clientID || newCaseID !== caseID) {
      setClientId(newClientID);
      setCaseId(newCaseID);
      dispatch(setCaseSummary(null));
      dispatch(setCurrentCase(null));
      dispatch(setClientProviders(null));
    }
  }, [location, dispatch]);

  const currentCase = useSelector((state) => state?.caseData?.current);
  const caseSummaryState = useSelector((state) => state?.caseData?.summary);
  const timelineEvents = useSelector((state) => state?.caseData?.summary?.timeline_events);
  const timelineSections = useMemo(
    () => buildCaseTimelineSections(timelineEvents),
    [timelineEvents]
  );
  const statueOfLimitation = useSelector(
    (state) => state?.caseData?.summary?.case_statute_limitations
  );
  const client = useSelector((state) => state?.client?.current);
  const client_providers = useSelector((state) => state.clientProvider.all);

  const [counsellingOpen, setCounsellingOpen] = useState(false);
  const [addNewClientOnCaseOpen, setAddNewClientOnCase] = useState(false);
  const [isChangeFirmAddress, setIsChangeFirmAddress] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const {
    relationships: coCounselRelationships,
    error: coCounselError,
    refresh: refreshCoCounsel,
  } = useCoCounsel(clientId, currentCaseId);
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  const fetchCaseSummaryApi = useCallback(
    async (clientId, caseId) => {
      try {
        const response = await api_without_cancellation.get(
          `/api/cases/${clientId}/${caseId}/summary/`
        );
        dispatch(setCaseSummary(response.data));
      } catch (e) {
        console.error(e);
      }
    },
    [dispatch]
  );

  const fetchLitigationData = async () => {
    try {
      const litigation_data = await api_without_cancellation.get(
        `/api/litigation-page/litigation/?case_id=${currentCaseId}&client_id=${clientId}`
      );
      if (litigation_data.status === 200) {
        setLitigationData(litigation_data.data);
      }
    } catch (error) {
      console.error("Failed to fetch Litigation Data:", error);
    }
  };

  // const getEventType = useCallback(async () => {
  //   try {
  //     const response = await api_without_cancellation.get("/api/all/event/types/");
  //     setEventTypesData(response.data.data);
  //   } catch (err) {
  //     console.error("Error fetching Event Types:", err);
  //   }
  // }, [origin]);

  const fetchBlockedStatus = useCallback(async () => {
    try {
      const response = await api_without_cancellation.get(
        `/api/litigation-page/litigation-act-blocked-status/${clientId}/${currentCaseId}/`
      );
      if (response.status === 200) {
        setIsBlocked(response.data.blocked);
      }
    } catch (error) {
      console.error("Error fetching blocked status:", error);
    }
  }, [clientId, currentCaseId, origin]);

  useEffect(() => {
    const newClientID = location.pathname.split("/")[2] || getClientId();
    const newCaseID = location.pathname.split("/")[3] || getCaseId();

    // 1. Always fetch when this effect runs (mount, client change, URL change, or update flag)
    fetchLitigationData();
    fetchCaseSummaryApi(newClientID, newCaseID);
    fetchShakespeareStatus(newCaseID, 1, dispatch);

    // include everything that should deliberately trigger a fresh fetch
  }, [client, location.pathname]);

  useEffect(() => {
    if (isLitigationActDataUpdated && setLitigationActDataUpdated) {
      fetchCaseSummaryApi(clientId, currentCaseId);
    }
  }, [isLitigationActDataUpdated]);

  const memoizedDataForFirstTd = useMemo(
    () => createCaseSummaryData(caseSummaryState),
    [caseSummaryState]
  );

  const memoizedDataForSecondTD = useMemo(
    () => createStatuteLimitationsData(statueOfLimitation),
    [caseSummaryState]
  );

  const memoizedDataForThirdTD = useMemo(
    () => createClientsData(caseSummaryState),
    [caseSummaryState]
  );

  const handleSwitchCase = useCallback(
    async (clientRow) => {
      const selectedClientId = clientRow?.clientData?.id;
      const selectedCaseId = getCaseId();

      if (!selectedClientId || !selectedCaseId || String(selectedClientId) === getClientId()) {
        return;
      }

      dispatch(setComponentLoadingEffect("medicalProviders", true));
      dispatch(setComponentLoadingEffect("detailBar", true));

      try {
        await api_without_cancellation.get(
          `/api/switch_client/${selectedClientId}/${selectedCaseId}/1/`
        );

        setClientId(selectedClientId);
        setCaseId(selectedCaseId);

        const currentCasePromise = dispatch(fetchCurrentCase(selectedClientId, selectedCaseId));
        const pagesPromise = dispatch(fetchAllPages(selectedCaseId, true));

        const headerSummaryPromise = fetchHeaderSummary(selectedClientId, selectedCaseId)
          .then((data) => dispatch(setHeaderSummary(data)))
          .catch((error) => console.error("Failed to fetch header summary:", error));

        const caseSummaryPromise = fetchCaseSummary(selectedClientId, selectedCaseId)
          .then((data) => dispatch(setCaseSummary(data)))
          .catch((error) => console.error("Failed to fetch case summary:", error));

        const clientProvidersPromise = fetchCasePageClientProviders(
          selectedClientId,
          selectedCaseId
        )
          .then((data) => dispatch(setClientProviders(data?.results)))
          .catch((error) => console.error("Failed to fetch client providers:", error));

        await Promise.all([
          currentCasePromise,
          pagesPromise,
          headerSummaryPromise,
          caseSummaryPromise,
          clientProvidersPromise,
        ]);

        dispatch(setBlurEffect(false));
        dispatch(setHeaderName("Case"));

        navigate(`/bp-case/${selectedClientId}/${selectedCaseId}`, { replace: true });
      } catch (error) {
        console.error("Failed to switch client:", error);
      } finally {
        dispatch(setLoading({ key: "all", value: false }));
        dispatch(setComponentLoadingEffect("medicalProviders", false));
        dispatch(setComponentLoadingEffect("detailBar", false));
      }
    },
    [dispatch, navigate]
  );

  const handleClosePopup = useCallback(() => {
    if (showActPopup === true) {
      setShowActPopup(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showActPopup]);

  const [caseTypeModal, setCaseTypeModal] = useState(false);
  const panelConfig = {
    heading: "Open",
    // target: "#edit-case-dates-modal",
    data: memoizedDataForFirstTd,
    button: "Edit Case Type and Dates",
    leftHand: false,
    onClick: () => {
      //   console.log("Panel button clicked");
      // Additional logic if needed
      setCaseTypeModal(true);
    },
    clickId: 999,
  };
  const statueConfig = {
    heading: "Statute of Limitations",
    target: "",
    data: memoizedDataForSecondTD,
    button: "Statute of Limitations Deadline",
    leftHand: true,
    onClick: () => setShowActPopup(true),
    click: (baseObj) => setEditDetail(baseObj),
    clickId: 999,
  };
  const clientConfig = {
    data: memoizedDataForThirdTD,
    onClick: () => setAddNewClientOnCase(true),
    onRowClick: handleSwitchCase,
  };

  useEffect(() => {
    setCounsellingOpen(false);
  }, [clientId, currentCaseId]);
  const refreshCoCounselCase = useCallback(async () => {
    await Promise.all([refreshCoCounsel(), fetchCaseSummaryApi(clientId, currentCaseId)]);
  }, [refreshCoCounsel, fetchCaseSummaryApi, clientId, currentCaseId]);
  const counselingFirmsData = useMemo(
    () => createCounselingFirmsData(coCounselRelationships, refreshCoCounselCase),
    [coCounselRelationships, refreshCoCounselCase]
  );
  const counselingFirmsConfig = {
    heading: "CO-COUNSELlING FIRMS",
    data: counselingFirmsData,
    button: "CoCounseling Firm",
    leftHand: true,
    onClick: () => setCounsellingOpen(true),
    clickId: 999,
  };

  const [currentPage, setCurrentPage] = useState("home");
  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  const mainTabs = useMemo(() => {
    const tabs = [];
    //
    tabs.push({
      id: "home",
      label: "Home",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("home"),
      leftHand: false,
    });

    tabs.push({
      id: "summary-case-page",
      label: "Summary",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("summary-case-page"),
      leftHand: false,
    });

    return tabs;
  }, [handlePageChange]);

  const buttonTabs = useMemo(() => {
    const tabs = [];

    // Expert add button with gold icon
    // tabs.push({
    //   id: "new-client-on-case",
    //   label: "New Client on Case",
    //   className: "tab-trapezium-cycles-corners",
    //   background: "var(--primary-60)",
    //   left: "0px",
    //   onClick: () => setAddNewClientOnCase(true),
    //   leftHand: true,
    //   span: (
    //     <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
    //       <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
    //     </span>
    //   ),
    // });

    // tabs.push({
    //   id: "new-co-counseling-firm",
    //   label: "CoCounseling Firm",
    //   className: "tab-trapezium-cycles-corners",
    //   background: "var(--primary-60)",
    //   left: "0px",
    //   onClick: () => setCounsellingOpen(true),
    //   leftHand: true,
    //   span: (
    //     <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
    //       <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
    //     </span>
    //   ),
    // });

    return tabs;
  }, []);

  const photoTabs = useMemo(
    () => [
      {
        id: "docs",
        label: "Docs",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("docs"),
        leftHand: true,
        span: (
          <span className="fw-bold ic-15 d-flex align-items-center">
            <img
              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/documents-icon-color_b6TvcB7.svg"
              width={15}
              height={15}
              style={{ filter: hasDocs ? "none" : "grayscale(100%)" }}
              alt=""
            />
          </span>
        ),
      },
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
                filter: hasPhotos ? "none" : "grayscale(100%)",
              }}
              alt=""
            />
          </span>
        ),
      },
    ],
    [handlePageChange, hasDocs, hasPhotos]
  );

  const caseTimelineRef = useRef(null);
  const { gridRef: panelsGridRef, counselOnOwnRow } = useCaseHomePanelsLayout(
    coCounselRelationships,
    isValid && currentPage === "home"
  );
  const containerRef = useRef(null);
  const secondRef = useRef(null);

  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(440);
  const [completionPages, setCompletionPages] = useState([]);
  const [selectedVerificationPage, setSelectedVerificationPage] = useState(null);
  const [selectedChecklistItems, setSelectedChecklistItems] = useState([]);
  const [selectedVerification, setSelectedVerification] = useState(null);
  const [selectedActiveVerification, setSelectedActiveVerification] = useState(null);
  const [verificationModal, setVerificationModal] = useState(null);
  const [loadingVerificationPageId, setLoadingVerificationPageId] = useState(null);
  // useEffect(() => {
  //   const calculateRows = () => {
  //     // if (timelineEvents.length === 0) {
  //     //   //   setRowCount(0);
  //     //   return;
  //     // }

  //     const leftSideEl1 = containerRef.current?.offsetHeight || 0;
  //     const leftSideEl2 = secondRef.current?.offsetHeight || 0;
  //     setHeight(leftSideEl1);
  //     const availableHeight = leftSideEl1 - 25;
  //     // const availableHeight = mainHeight - 25;
  //     const rows = Math.floor(availableHeight / 21);
  //     let addRows;

  //     const data = timelineEvents?.length * 2;
  //     const finalRows = rows - data;

  //     setRowCount(finalRows);
  //   };

  //   calculateRows();

  //   window.addEventListener("resize", calculateRows);

  //   return () => {
  //     window.removeEventListener("resize", calculateRows);
  //   };
  // }, [containerRef, secondRef, timelineEvents, client_providers]);
  const [shouldScroll, setShouldScroll] = useState(false);
  const { data: specialitiesList, refetch: refetchSpecial } = useGetCaseSpecialities();
  const [selectedSpeciality, setSelectedSpeciality] = useState("all");

  useEffect(() => {
    const calculateRows = () => {
      const leftSideEl1 = containerRef.current?.offsetHeight || 0;
      setHeight(leftSideEl1);
      const availableHeight = Math.max(0, leftSideEl1 - 25); // Subtract header height
      const eventRowsHeight = timelineSections.length * 21;

      // Check if content overflows
      if (eventRowsHeight > availableHeight) {
        // Content overflows - enable scrolling
        setShouldScroll(true);
        setRowCount(0); // No fake rows needed
      } else {
        // Content fits - disable scrolling and fill remaining space
        setShouldScroll(false);
        const remainingHeight = availableHeight - eventRowsHeight;
        const fullRows = Math.floor(remainingHeight / 21);
        const partialRowHeight = remainingHeight % 21;

        setRowCount(partialRowHeight > 0 ? fullRows + 1 : fullRows);
      }
    };

    calculateRows();
    window.addEventListener("resize", calculateRows);
    return () => window.removeEventListener("resize", calculateRows);
  }, [containerRef, secondRef, timelineSections, client_providers, selectedSpeciality]);

  const specialitiesContainerRef = useRef(null);
  const [specialityWidth, setSpecialityWidth] = useState(25);

  const calculateSpecialityWidths = () => {
    if (!specialitiesList?.length) return;
    if (!specialitiesContainerRef.current) return;

    // Step 1: Create temporary hidden container to measure natural widths
    const tempContainer = document.createElement("div");
    tempContainer.style.position = "absolute";
    tempContainer.style.visibility = "hidden";
    tempContainer.style.display = "flex";
    tempContainer.style.gap = "5px";
    document.body.appendChild(tempContainer);

    // Step 2: Create clones and measure their natural widths
    let maxNaturalWidth = 0;
    specialitiesList.forEach((special) => {
      const tempDiv = document.createElement("div");
      tempDiv.style.padding = "0px 5px";
      tempDiv.style.whiteSpace = "nowrap";
      tempDiv.style.fontWeight = "600";
      tempDiv.style.textTransform = "uppercase";
      tempDiv.style.height = "25px";
      tempDiv.style.lineHeight = "25px";
      tempDiv.textContent = special?.name;

      tempContainer.appendChild(tempDiv);
      const width = tempDiv.getBoundingClientRect().width;
      maxNaturalWidth = Math.max(maxNaturalWidth, width);
    });

    // Step 3: Clean up temporary container
    document.body.removeChild(tempContainer);

    // Step 4: Get available width per item
    const parentWidth = specialitiesContainerRef.current.getBoundingClientRect().width;
    const gap = 5;
    const totalGaps = (specialitiesList.length - 1) * gap;
    const availableWidth = parentWidth - totalGaps - 45.63;
    const equalShareWidth = availableWidth / specialitiesList.length;

    // Step 5: Use the SMALLER of: natural max width OR equal share width
    const finalWidth = Math.max(25, Math.min(equalShareWidth));

    setSpecialityWidth(finalWidth);
  };
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      calculateSpecialityWidths();
    }, 100);

    window.addEventListener("resize", calculateSpecialityWidths);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", calculateSpecialityWidths);
    };
  }, [specialitiesList, client_providers?.length]);

  const { data: caseProvidersList } = useGetCaseProviders();
  const [newProviderShow, setNewProviderShow] = useState(false);
  const handleNewProviderClose = useCallback((shouldRefresh = false) => {
    setNewProviderShow(false);

    if (shouldRefresh === "true") {
      dispatch(setComponentLoadingEffect("medicalProviders", true));
      fetchCasePageClientProviders(getClientId(), getCaseId())
        .then((data) => {
          dispatch(setClientProviders(data?.results));
          setLoading({
            key: "all",
            value: false,
          });
          dispatch(setComponentLoadingEffect("medicalProviders", false));
        })
        .catch((error) => {
          console.error("Error occurred while fetching client-providers", error);
          dispatch(setComponentLoadingEffect("medicalProviders", false));
          setLoading({
            key: "all",
            value: false,
          });
        });
      refetchSpecial();
    }
  }, []);

  useEffect(() => {
    setLoading({
      key: "all",
      value: true,
    });

    dispatch(setComponentLoadingEffect("medicalProviders", true));
    fetchCasePageClientProviders(getClientId(), getCaseId())
      .then((data) => {
        dispatch(setClientProviders(data?.results));
        setLoading({
          key: "all",
          value: false,
        });
        dispatch(setComponentLoadingEffect("medicalProviders", false));
      })
      .catch((error) => {
        console.error("Error occurred while fetching client-providers", error);
        dispatch(setComponentLoadingEffect("medicalProviders", false));
        setLoading({
          key: "all",
          value: false,
        });
      });
  }, []);

  const [firmName, setFirmName] = useState();

  useEffect(() => {
    async function fetchFirmName() {
      try {
        const response = await api_without_cancellation.get(
          `/api/cases/${getClientId()}/${getCaseId()}/summary/`
        );

        setFirmName(response?.data);
      } catch (error) {
        console.error("Error fetching firm name:", error);
      }
    }

    fetchFirmName();
  }, [getClientId(), getCaseId()]);
  const { selectedRoleIds, loading, error, refetch } = useTelephonySettings();

  const isSOLEventType = (eventTypeName) =>
    eventTypeName === "Statute of Limitations" ||
    eventTypeName === "Statute Of Limitations" ||
    eventTypeName === "S.O.L";

  // Icon shown before a timeline event name (Litigation -> event_type icon, SOL -> SOL icon)
  const renderTimelineEventIcon = (x) => {
    if (x.type === "SOL") {
      return (
        <span
          className="d-inline-flex align-items-center justify-content-center ic ic-15 m-r-5"
          style={{ flexShrink: 0 }}
        >
          <img src={SOLicon} className="ic-15" alt="" />
        </span>
      );
    }
    const eventTypeName = x?.event?.event_type_id?.litigation_event_type;
    if (isSOLEventType(eventTypeName)) {
      return (
        <span
          className="d-inline-flex align-items-center justify-content-center ic ic-15 m-r-5"
          style={{ flexShrink: 0 }}
        >
          <img src={SOLicon} className="ic-15" alt="" />
        </span>
      );
    }
    if (eventTypeName === "Expert Discovery") {
      return (
        <span
          className="d-inline-flex align-items-center justify-content-center ic ic-15 m-r-5"
          style={{ flexShrink: 0 }}
        >
          <img src={ExpertDiscovery} className="ic-15" alt="" />
        </span>
      );
    }
    return (
      <i
        className={`ic ic-15 ${EVENT_TYPE_ICONS[eventTypeName] || "ic-Event"} m-r-5`}
        style={{ flexShrink: 0 }}
      />
    );
  };

  const renderTimelineSection = (section, index) => {
    const key = `timeline-${section.type}-${section.entry?.type || ""}-${section.entry?.event?.id ?? section.dateKey ?? ""}-${index}`;
    const rowStyle = {
      padding: "0px 5px",
      height: "21px",
      minHeight: "21px",
      fontWeight: "600",
    };
    const textStyle = {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      minWidth: 0,
    };

    switch (section.type) {
      case "daySpacer":
        return <div key={key} aria-hidden="true" style={{ height: "21px", minHeight: "21px" }} />;
      case "dateHeading": {
        const dayName = courtWeekday(section.dateKey);
        const formattedDate = formatCourtDate(section.dateKey);
        return (
          <div
            key={key}
            className="d-flex justify-content-center align-items-center task"
            style={{
              ...rowStyle,
              color: "var(--primary)",
              backgroundColor: "var(--primary-20)",
            }}
          >
            <strong style={textStyle} title={`${dayName}, ${formattedDate}`}>
              {dayName}, {formattedDate}
            </strong>
          </div>
        );
      }
      case "categoryLabel":
        return (
          <div
            key={key}
            className="d-flex justify-content-center align-items-center task"
            style={{ ...rowStyle, color: "var(--primary)" }}
          >
            <strong>{section.label}</strong>
          </div>
        );
      case "clientRow":
        return (
          <div
            key={key}
            className="d-flex align-items-center task"
            style={{ ...rowStyle, paddingLeft: "5px" }}
          >
            <span
              className="ic ic-avatar ic-15 has-avatar-icon has-cover-img bg-white m-r-5"
              style={{ minWidth: "15px", flexShrink: 0 }}
            >
              <img
                src={section.client?.profile_pic_19p || avatarImage}
                className="theme-ring"
                alt=""
                style={{ background: "var(--primary-30)" }}
              />
            </span>
            <span style={textStyle}>
              {section.client?.first_name} {section.client?.last_name}
            </span>
          </div>
        );
      case "eventTypeHeading":
        return (
          <div key={key} className="d-flex align-items-center task" style={rowStyle}>
            {section.entry.type === "TreatmentDates" ? (
              <span
                className="d-flex align-items-center justify-content-center text-white specialty-icon m-r-5"
                style={{
                  backgroundColor: section.entry.event.specialty?.color || "var(--primary)",
                  height: "15px",
                  width: "15px",
                  flexShrink: 0,
                }}
                title={section.entry.event.specialty?.name || "Treatment Dates"}
              >
                {section.entry.event.specialty?.name?.[0] || "T"}
              </span>
            ) : (
              renderTimelineEventIcon(section.entry)
            )}
            <span style={textStyle} title={section.eventType}>
              {section.eventType}
            </span>
          </div>
        );
      case "eventName":
        return (
          <div
            key={key}
            className="d-flex align-items-center task"
            style={{ ...rowStyle, paddingLeft: "5px" }}
          >
            <span style={textStyle} title={section.entry.event.name || ""}>
              {section.entry.event.name}
            </span>
          </div>
        );
      default:
        return null;
    }
  };

  const fetchComplete = useCallback(async () => {
    try {
      const [response, checklistResponse] = await Promise.all([
        api_without_cancellation.get("/api/page-completion-verification/pages/", {
          params: { case_id: currentCaseId, client_id: clientId },
        }),
        api_without_cancellation
          .get(`/api/commulative-checklist/${clientId}/${currentCaseId}/`)
          .catch((error) => {
            console.error("Failed to fetch page completion percentages:", error);
            return null;
          }),
      ]);
      const percentagesByPageId = new Map(
        Object.values(checklistResponse?.data?.all_checklists || {})
          .filter((checklist) => checklist?.page)
          .map((checklist) => [String(checklist.page.id), Number(checklist.percentage) || 0])
      );
      setCompletionPages(
        (response.data?.pages || []).map((page) => ({
          ...page,
          percentage: percentagesByPageId.get(String(page.id)) ?? 0,
        }))
      );
    } catch (error) {
      console.error("Failed to fetch page verification status:", error);
      setCompletionPages([]);
    }
  }, [clientId, currentCaseId]);

  useEffect(() => {
    fetchComplete();
  }, [currentCaseId, fetchComplete]);

  const fetchSelectedVerificationData = useCallback(
    async (page) => {
      const response = await api_without_cancellation.get("api/page_checklist/", {
        params: {
          case_id: currentCaseId,
          client_id: clientId,
          page_id: page.id,
        },
      });
      const responseData = response.data || {};
      setSelectedChecklistItems(responseData.final_checklist || []);
      setSelectedVerification(responseData.is_verified ?? null);
      setSelectedActiveVerification(responseData.active_verification ?? null);
      return responseData;
    },
    [clientId, currentCaseId]
  );

  const handleVerificationPageClick = useCallback(
    async (page) => {
      if (loadingVerificationPageId !== null) return;
      setLoadingVerificationPageId(page.id);
      setSelectedVerificationPage(page);

      try {
        const responseData = await fetchSelectedVerificationData(page);
        const percentage = Number(responseData.checklist_casepercentage) || 0;

        if (responseData.is_verified) {
          setVerificationModal("undo");
        } else if (percentage === 100) {
          setVerificationModal("verify");
        } else {
          setVerificationModal("blocked");
        }
      } catch (error) {
        console.error("Failed to fetch page checklist:", error);
      } finally {
        setLoadingVerificationPageId(null);
      }
    },
    [fetchSelectedVerificationData, loadingVerificationPageId]
  );

  const refreshSelectedVerification = useCallback(async () => {
    if (selectedVerificationPage) {
      await fetchSelectedVerificationData(selectedVerificationPage);
    }
    await fetchComplete();
  }, [fetchComplete, fetchSelectedVerificationData, selectedVerificationPage]);

  const verificationRowHeight = 21;
  const verificationAvailableHeight = Math.max(height - 25, 0);
  const verificationContentHeight = completionPages.length * verificationRowHeight;
  const verificationShouldScroll = verificationContentHeight > verificationAvailableHeight;
  const verificationRemainingHeight = verificationShouldScroll
    ? 0
    : verificationAvailableHeight - verificationContentHeight;
  const verificationFakeRowCount = Math.floor(verificationRemainingHeight / verificationRowHeight);
  const verificationPartialRowHeight = verificationRemainingHeight % verificationRowHeight;

  const renderCasePhoto = (slotIndex) => {
    const photoSlot = caseSummaryState?.processed_photo_slots?.[slotIndex];

    if (!photoSlot) return null;

    if (!photoSlot?.photo) {
      return (
        <DefaultThumbnail
          {...defaultThumbnailProps}
          height="151px"
          photoData={photoSlot}
          photoSlots={caseSummaryState?.processed_photo_slots}
          pageName={pageObject?.name || "Case"}
          refetch={() =>
            Promise.all([fetchCaseSummaryApi(getClientId(), getCaseId()), refreshPhotos()])
          }
        />
      );
    }

    return (
      <PhotoSlot
        height="151"
        photoSlot={photoSlot?.photo}
        photoSlots={caseSummaryState?.processed_photo_slots}
        pageName={pageObject?.name || "Case"}
        slotNumber={photoSlot?.photo?.photo_slot?.slot_number}
        refetch={() => {
          fetchCaseSummaryApi(getClientId(), getCaseId());
          refreshPhotos();
        }}
      />
    );
  };

  if (!isValid) {
    return null; // or a loading spinner, or redirect to login
  }

  return (
    <>
      <ClientProvidersStyles clientProviders={client_providers} />

      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="1" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            {/*  */}
            {/* <ResponsiveTabThreeItems
              HandlePage={currentPage}
              tabsData={mainTabs}
              addTab={buttonTabs}
              photoTab={photoTabs}
              handlePageChange={handlePageChange}
            /> */}
            <SmartResponsiveTabsContainer
              HandlePage={currentPage}
              tabsData={mainTabs}
              viewTab={[]}
              addTab={buttonTabs}
              photoTab={photoTabs}
              photoTabControlled={true}
              handlePageChange={handlePageChange}
              viewType={""}
            />
            {currentPage !== "docs" && currentPage !== "photo" && (
              <div
                style={{
                  width: "100%",
                  justifyContent: "flex-start",
                  background: "var(--primary)",
                  height: "25px",
                  marginBottom: "5px",
                }}
              >
                <span
                  className="fw-bold text-white"
                  style={{
                    height: "25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {currentPage === "home"
                    ? "Case Home"
                    : currentPage === "summary-case-page"
                      ? "Case Summary"
                      : ""}
                </span>
              </div>
            )}
            {/* New Case Page Content Goes Here */}
            {currentPage === "home" && (
              <>
                <div
                  className="d-flex"
                  style={{
                    gap: "5px",
                  }}
                >
                  <div
                    className="d-flex flex-column m-b-5"
                    style={{
                      flex: "1 1 0",
                      minWidth: 0,
                      gap: "5px",
                      width: "calc(100% - 328px - 10px)",
                      maxHeight: "max-content",
                    }}
                    ref={containerRef}
                  >
                    <div
                      ref={panelsGridRef}
                      className={`case-home-panels-grid${counselOnOwnRow ? " case-home-panels-grid-counsel-own-row" : ""}`}
                    >
                      {/* =========================================
      PHOTO 1
  ========================================= */}
                      <div className="case-home-grid-photo-1">{renderCasePhoto(0)}</div>

                      {/* =========================================
      OPEN CASE
  ========================================= */}
                      <div className="case-home-grid-open">
                        <NewCasePanels
                          panel_name={panelConfig.heading}
                          data={panelConfig.data}
                          hasBtn={true}
                          hideFooterButton
                          buttonText={panelConfig.button}
                          onClick={panelConfig.onClick}
                          target={panelConfig.target}
                          panelClassName="case-home-responsive-panel"
                          clickId={panelConfig.clickId}
                          colorGiven={"var(--primary-25)"}
                        />
                      </div>

                      {/* =========================================
      CLIENTS ON CASE
  ========================================= */}
                      <div className="case-home-grid-clients">
                        <ClientsOnCasePanel
                          data={clientConfig.data}
                          onAddClient={clientConfig.onClick}
                          onRowClick={clientConfig.onRowClick}
                        />
                      </div>

                      {/* =========================================
      PHOTO 2
  ========================================= */}
                      <div className="case-home-grid-photo-2">{renderCasePhoto(1)}</div>

                      {/* =========================================
      CASE HOME OFFICE
  ========================================= */}
                      <div className="case-home-grid-office">
                        <CasePageContactPanel
                          id={currentCase?.id}
                          panel_name="Case Home Office"
                          className="pe-0 case-home-responsive-panel"
                          title={""}
                          isCaseHomeOffice={true}
                          name={currentCase?.for_client?.created_by?.office_name}
                          address1={currentCase?.firm_addresses?.address1}
                          nickName={currentCase?.firm_addresses?.nickname}
                          address2={currentCase?.firm_addresses?.address2}
                          city={currentCase?.firm_addresses?.city}
                          websiteURL={currentCase?.firm_addresses?.website}
                          state={currentCase?.firm_addresses?.state}
                          zip_code={currentCase?.firm_addresses?.zip}
                          phone_number={currentCase?.firm_addresses?.phone_number}
                          ext={currentCase?.firm_addresses?.phone_ext ?? ""}
                          fax_number={currentCase?.firm_addresses?.fax}
                          onSelectObject={() => {
                            addClickRecord(999, 1);
                            setIsChangeFirmAddress(true);
                            setSelectedLocationId(currentCase?.firm_addresses?.id ?? null);
                          }}
                        />
                      </div>

                      {/* =========================================
      STATUTE OF LIMITATIONS
  ========================================= */}
                      <div className="case-home-grid-sol">
                        <NewCasePanels
                          panel_name={statueConfig.heading}
                          data={statueConfig.data}
                          hasBtn={true}
                          hideFooterButton
                          buttonText={statueConfig.button}
                          onClick={statueConfig.onClick}
                          click={statueConfig.click}
                          leftHand={statueConfig.leftHand}
                          panelClassName="case-home-responsive-panel"
                          clickId={statueConfig.clickId}
                        />
                      </div>

                      {/* =========================================
      CO-COUNSELLING FIRMS
  ========================================= */}
                      <div className="case-home-grid-counselling">
                        <NewCasePanels
                          panel_name={counselingFirmsConfig.heading}
                          data={counselingFirmsConfig.data}
                          hasBtn={true}
                          hideFooterButton
                          buttonText={counselingFirmsConfig.button}
                          onClick={counselingFirmsConfig.onClick}
                          leftHand={counselingFirmsConfig.leftHand}
                          panelClassName="case-home-responsive-panel min-co-counselling"
                          panelClassSpan="w-100"
                        />
                      </div>
                    </div>
                    <div>
                      {(specialitiesList?.length > 0 || client_providers?.length > 0) && (
                        <CasePageFilters
                          specialitiesList={specialitiesList ?? []}
                          activeSpecialty={selectedSpeciality}
                          onSpecialtyChange={setSelectedSpeciality}
                          setMaxWidth={() => {}}
                          specialitiesContainerRef={specialitiesContainerRef}
                          specialityWidth={specialityWidth}
                          onAddProvider={
                            client_providers?.length > 0
                              ? () => setNewProviderShow(true)
                              : undefined
                          }
                        />
                      )}
                      {newProviderShow && (
                        <AddNewProvider
                          show={newProviderShow}
                          handleClose={() => {
                            handleNewProviderClose("true");
                          }}
                          firmName={firmName}
                          caseProvider={caseProvidersList}
                          specialitie={specialitiesList}
                        />
                      )}
                      <div className="table-responsive table--no-card border-0 has-table-sub-panel">
                        <div className="d-xxxl-none">
                          <MedicalProviders
                            id={selectedSpeciality}
                            refetchSpecial={refetchSpecial}
                          />
                        </div>

                        <div className="d-none d-xxxl-block">
                          <MedicalProvidersTable
                            id={selectedSpeciality}
                            refetchSpecial={refetchSpecial}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="case-verification-column m-b-5" style={{ height: `${height}px` }}>
                    <div className="menu-bar-style client-contact-title case-side-column-title">
                      Verifications
                    </div>
                    <div
                      className="case-verification-list"
                      style={{ overflowY: verificationShouldScroll ? "auto" : "hidden" }}
                    >
                      {completionPages.map((page) => (
                        <div
                          className="case-verification-row cursor-pointer"
                          key={page.id}
                          title={page.name}
                          role="button"
                          tabIndex={0}
                          aria-busy={loadingVerificationPageId === page.id}
                          onClick={() => handleVerificationPageClick(page)}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              handleVerificationPageClick(page);
                            }
                          }}
                        >
                          <img
                            src={page.page_icon}
                            className="case-verification-page-icon"
                            alt=""
                          />
                          <span className="case-verification-page-name">{page.name}</span>
                          <img
                            src={
                              page.is_verified
                                ? VerifiedIcon
                                : page.percentage === 100
                                  ? verifiedReadyIcon
                                  : verifiedNoIcon
                            }
                            className="case-verification-status-icon"
                            alt={
                              page.is_verified
                                ? "Verified"
                                : page.percentage === 100
                                  ? "Ready to verify"
                                  : "Not verified"
                            }
                          />
                        </div>
                      ))}
                      {!verificationShouldScroll &&
                        Array.from({ length: verificationFakeRowCount }, (_, index) => (
                          <div
                            aria-hidden="true"
                            className="case-verification-row case-verification-fake-row"
                            key={`verification-fake-row-${index}`}
                          />
                        ))}
                      {!verificationShouldScroll && verificationPartialRowHeight > 0 && (
                        <div
                          aria-hidden="true"
                          className="case-verification-row case-verification-fake-row"
                          style={{
                            height: `${verificationPartialRowHeight}px`,
                            minHeight: `${verificationPartialRowHeight}px`,
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className=" m-b-5"
                    style={{
                      width: "188px",
                      flex: "0 0 188px",
                      // background: "red",
                      // height: "100%",
                      overflowY: shouldScroll ? "scroll" : "hidden",
                      scrollbarWidth: "none",
                      marginTop: "0px",
                      maxHeight: `${height}px`,
                    }}
                    ref={caseTimelineRef}
                  >
                    <div
                      className="menu-bar-style client-contact-title text-center d-flex justify-content-center align-items-center"
                      style={{
                        height: "25px",
                        position: "sticky",
                        top: "0px",
                      }}
                    >
                      Case Timeline
                    </div>
                    {timelineSections.map(renderTimelineSection)}
                    {Array.from({ length: rowCount }, (_, index) => (
                      <div
                        key={`fake-row-${rowCount + index}`}
                        className="fake-new-case-page-row"
                        style={{ height: "21px" }}
                      >
                        {/*  */}
                      </div>
                    ))}
                  </div>
                </div>

                <WorkersOnCase selectedRoleIds={selectedRoleIds} />
                {/* <div className="row mx-auto documents-wrapper" style={{ marginRight: "0px" }}>
                  <div className="col-12 ps-0 pe-0">
                    <DocumentRow
                      clientProvider={currentCaseId}
                      pageName={pageObject?.name}
                      page_id={1}
                      showESignatures
                    />
                  </div>
                </div> */}
                <div className="d-flex documents-wrapper" style={{ marginRight: "0px" }}>
                  <div className="col-12 pe-0">
                    <ClientDocumentRow
                      clientProvider={currentCaseId}
                      pageName={pageObject?.name}
                      page_id={1}
                      showSaveToPage={false}
                      onAttachmentsChange={refreshDocs}
                    />
                  </div>
                </div>
              </>
            )}

            {currentPage === "docs" && (
              <PageDocsTab
                key={`${clientId}-${currentCaseId}`}
                pageId={1}
                pageName={pageObject?.name}
                pageIcon={pageObject?.page_icon}
                onAttachmentsChange={refreshDocs}
              />
            )}

            {currentPage === "photo" && (
              <>
                <PhotoTab
                  key={`${clientId}-${currentCaseId}`}
                  pageId={1}
                  pageName={"Case"}
                  onAttachmentsChange={refreshPhotos}
                />
              </>
            )}
            <NotesSectionDashboard pageName={"Case"} />
          </div>
        </div>
      </div>

      <Footer />

      {addNewClientOnCaseOpen && (
        <AddNewClientModal setOpen={setAddNewClientOnCase} open={addNewClientOnCaseOpen} />
      )}

      {caseTypeModal && (
        <>
          <EditCaseTypeDateModal show={caseTypeModal} handleClose={() => setCaseTypeModal(false)} />
        </>
      )}

      {isChangeFirmAddress && (
        <ChangeOfficeFirmLocationModal
          selectedLocationId2={selectedLocationId}
          showModal={isChangeFirmAddress}
          handleClose={() => {
            addClickRecord(999, 1);
            setIsChangeFirmAddress(false);
          }}
        />
      )}

      {counsellingOpen && (
        <CounsellingModal
          setOpen={setCounsellingOpen}
          open={counsellingOpen}
          close={() => {
            addClickRecord(999, 1);
            setCounsellingOpen(false);
          }}
          refetch={refreshCoCounselCase}
          clientId={clientId}
          caseId={currentCaseId}
        />
      )}
      {editDetail && (
        <EditSOLPopup
          showPopup={editDetail}
          handleClose={() => setEditDetail(null)}
          litigationDetail={litigationData?.litigation}
          act={editDetail}
        />
      )}
      {showActPopup && (
        <SOLActPopupCasePage
          showPopup={showActPopup}
          handleClose={handleClosePopup}
          litigationDetail={litigationData?.litigation}
          isBlocked={isBlocked}
          refetch={() => fetchCaseSummaryApi(clientId, currentCaseId)}
        />
      )}
      {verificationModal === "verify" && selectedVerificationPage && (
        <VerifyCompletionModal
          pageObj={selectedVerificationPage}
          items={selectedChecklistItems}
          onVerified={refreshSelectedVerification}
          onClose={() => setVerificationModal(null)}
        />
      )}
      {verificationModal === "undo" && selectedVerificationPage && (
        <VerifyCompleteUndoModal
          pageObj={selectedVerificationPage}
          verification={selectedVerification}
          activeVerification={selectedActiveVerification}
          onUndone={refreshSelectedVerification}
          onClose={() => setVerificationModal(null)}
        />
      )}
      {verificationModal === "blocked" && (
        <VerifyBlockedModal onClose={() => setVerificationModal(null)} />
      )}
    </>
  );
};

export default NewCasePage;
